import { useLocation } from 'react-router-dom'
import {
    SidebarWrap,
    SidebarMenu,
    SidebarItem,
    SidebarLink
} from './sidebarElements'

const Sidebar = ({type}) => {
    const location = useLocation()
    if(type === 'edit') return (
        <SidebarWrap>
            <SidebarMenu>
                <SidebarItem>
                    <SidebarLink className={location.pathname === '/admin/news' && 'active'} to='/admin/news'>Danh sách bài viết</SidebarLink>
                </SidebarItem>
            </SidebarMenu>
        </SidebarWrap>
    )

    return (
        <SidebarWrap>
            <SidebarMenu>
                <SidebarItem>
                    <SidebarLink className={location.pathname === '/admin/news' && 'active'} to='/admin/news'>Danh sách bài viết</SidebarLink>
                </SidebarItem>
                <SidebarItem>
                    <SidebarLink className={location.pathname === '/admin/news/create' && 'active'} to='/admin/news/create'>Viết bài mới</SidebarLink>
                </SidebarItem>
            </SidebarMenu>
        </SidebarWrap>
    )
}

export default Sidebar
